const suffix = ["th", "st", "nd", "rd"];

export const ordinalNumber = (number) => {
  return `${number}${
    suffix[((number % 100) - 20) % 10] || suffix[number] || suffix[0]
  }`;
};
